import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.makeReportGeneral.success: {
            return action.payload;
        }

        case constants.makeReportGeneral.try:
        case constants.makeReportGeneral.error: {
            return initialState;
        }

        default:
            return state;
    }
}